import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/chocolate-ice-cream-dessert1.png'
import _imports_1 from '../assets/flat-lay-ice-cream-frame1.png'
import _imports_2 from '../assets/Arrow2.svg'


const _hoisted_1 = { class: "container grid items-center grid-cols-1 gap-8 px-5 mx-auto my-16 md:px-8 md:grid-cols-2 sm:gap-12 lg:gap-16" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "object-cover",
  alt: "",
  loading: "lazy",
  "data-aos": "fade-up"
}, null, -1)
const _hoisted_3 = {
  "data-aos": "fade-up",
  class: "flex items-center justify-center text-center text-dark"
}
const _hoisted_4 = { class: "text-2xl text-dark" }
const _hoisted_5 = { class: "w-3/4 mx-auto mt-2 text-lg font-medium leading-relaxed" }
const _hoisted_6 = { class: "flex items-center justify-center gap-5 mx-auto my-8 leading-relaxed tracking-wide" }
const _hoisted_7 = {
  class: "container grid items-center grid-cols-1 gap-8 px-5 mx-auto my-16 leading-relaxed tracking-wide md:px-8 md:grid-cols-2 sm:gap-12 lg:gap-40 text-dark",
  "data-aos": "fade-up"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up",
  class: "relative p-5 rounded-lg bg-primary md:p-0 md:rounded-none md:order-2"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "object-cover w-full h-full transition-all transform border md:-translate-x-5 md:translate-y-5 border-primary",
    alt: "",
    loading: "lazy",
    src: _imports_1
  })
], -1)
const _hoisted_9 = {
  "data-aos": "fade-up",
  class: "flex items-center justify-center text-center text-dark md:order-1"
}
const _hoisted_10 = { class: "text-lg font-medium leading-relaxed text-center text-black" }
const _hoisted_11 = { class: "flex items-center justify-center gap-5 mx-auto my-8 leading-relaxed tracking-wide" }
const _hoisted_12 = {
  key: 0,
  class: "container px-5 mx-auto my-12 md:px-8"
}
const _hoisted_13 = { class: "my-5 text-2xl text-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "p-5" }
const _hoisted_16 = { class: "flex items-center mt-3 font-medium text-black focus:outline-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Subscribe = _resolveComponent("Subscribe")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_Brands = _resolveComponent("Brands")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('Home.landing.title1')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('Home.landing.description1')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "px-5 py-2 transition-all bg-white border text-primary rounded-2xl border-primary hover:scale-105",
              to: { name: 'Contact' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Home.contact')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "px-5 py-2 text-white transition-all transform bg-dark rounded-2xl hover:scale-105",
              to: { name: 'About' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Home.Read-more')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('Home.landing.description2')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "px-5 py-2 transition-all bg-white border text-primary rounded-2xl border-primary hover:scale-105",
              to: { name: 'Contact' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Home.contact')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "px-5 py-2 text-white transition-all transform bg-dark rounded-2xl hover:scale-105",
              to: { name: 'About' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Home.Read-more')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_Subscribe),
    ($setup.news)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t('Home.latest-news')), 1),
          _createVNode(_component_Swiper, {
            modules: $setup.modules,
            "slides-per-view": 1,
            "space-between": 30,
            breakpoints: {
        '640': {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        '768': {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        '1024': {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
            loop: false,
            navigation: "",
            style: {}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...$setup.news], (item) => {
                return (_openBlock(), _createBlock(_component_SwiperSlide, {
                  key: item,
                  navigation: "",
                  class: "w-full overflow-hidden shadow-2xl p-4 transition-all duration-500 bg-transparent rounded-lg hover:bg-white md:w-96 md:mx-6 xl:mb-5"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "object-contain h-48 mx-auto",
                      src: $setup.URL + item.image,
                      alt: "",
                      loading: "lazy"
                    }, null, 8, _hoisted_14),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('lang') == 'ar' ? item.title_ar : item.title_en), 1),
                      _createElementVNode("button", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Home.Read-more')), 1),
                        _createElementVNode("img", {
                          class: _normalizeClass(["mx-2 transform", _ctx.$t('lang') == 'ar' && 'rotate-180']),
                          src: _imports_2,
                          alt: ""
                        }, null, 2)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Brands)
  ], 64))
}